import { useContext } from "react";
import { AuthContext } from "../components/AuthContextProvider";
import { Role } from "../../generated/types";

export function useIsCompany() {
  const { accessToken, role } = useContext(AuthContext);

  return accessToken !== undefined && role === Role.Company;
}
